<template>
  <div>
    <vx-card heading-size="h1" class="mt-base mb-5" title="Teacher Help">
      <p class="mb-5">
        The videos and other documents below (use the 2 tabs to access them) will help you with
        organising and managing the Virtual Job Experience platform and your students.
      </p>

      <vs-tabs alignment="fixed" class="overwrite-tabs">
        <vs-tab label="Help Videos">
          <div class="tab-text my-5">
            <p class="mb-5">
              The following videos will step you through the various aspects of the system in your
              teacher account:
            </p>

            <div
              class="vx-row mt-10 flex items-center"
              v-for="(item, index) in help_items_videos"
              :key="index"
            >
              <div class="vx-col lg:w-1/2 md:w-2/3 w-full mb-base">
                <h5 class="mb-5">{{ item.title }}</h5>
                <p class="mb-5" v-html="item.text"></p>
              </div>
              <div class="vx-col lg:w-1/4 md:w-1/3 w-full mb-base pl-10">
                <button
                  type="button"
                  class="no-style img-click-button"
                  :aria-label="`Play video: ${item.title}`"
                  @click="showVideoPopup(item.video)"
                >
                  <img :src="item.image" class="img-responsive mx-auto cursor-pointer" alt="" />
                </button>
              </div>
            </div>
          </div>
        </vs-tab>
        <vs-tab label="Documents & Handouts">
          <div class="tab-text my-5">
            <p class="mb-5">
              The documents below will assist both you and your students. The student ones can be
              used as handouts if needed.
            </p>

            <div
              class="vx-row mt-10 flex items-center"
              v-for="(item, index) in help_items_documents"
              :key="index"
            >
              <div class="vx-col lg:w-1/2 md:w-2/3 w-full mb-base">
                <h5 class="mb-5">{{ item.title }}</h5>
                <p class="mb-5" v-html="item.text"></p>
              </div>
              <div class="vx-col lg:w-1/4 md:w-1/3 w-full mb-base pl-10">
                <a :href="item.url | blob_url" target="_blank">
                  <img
                    :src="item.image"
                    :alt="`${item.title} (opens in a new tab)`"
                    class="img-responsive mx-auto cursor-pointer"
                  />
                </a>
              </div>
            </div>
          </div>
        </vs-tab>
        <vs-tab label="Student Help Videos">
          <div class="tab-text my-5">
            <div
              class="vx-row mt-10 flex items-center"
              v-for="(item, index) in student_help_items_videos"
              :key="index"
            >
              <div class="vx-col lg:w-1/2 md:w-2/3 w-full mb-base">
                <h5 class="mb-5">{{ item.title }}</h5>
                <p class="mb-5" v-html="item.text"></p>
              </div>
              <div class="vx-col lg:w-1/4 md:w-1/3 w-full mb-base pl-10">
                <button
                  type="button"
                  class="no-style img-click-button"
                  :aria-label="`Play video: ${item.title}`"
                  @click="showVideoPopup(item.video)"
                >
                  <img :src="item.image" class="img-responsive mx-auto cursor-pointer" alt="" />
                </button>
              </div>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
import store from '@/store/store';
export default {
  data() {
    return {
      help_items_videos: [
        {
          title: 'Managing Settings',
          text: `You are able to tailor the platform and the experience for you students by adjusting some very basic settings.<br/><br/>
This will also allow you to modify the platform to suit the needs of the program(s) in your school.`,
          image: require('@/assets/images/teacherhelp/teacher_settings_button.jpg'),
          video: 'content/teacherhelp/teacher_settings.mp4',
        },
        {
          title: 'Viewing Student Activity (Overview)',
          text: "This video explains how you can get an overview of all your student's work experience activity. It will show you how you can filter results and all the different things you can see at a glance.",
          image: require('@/assets/images/teacherhelp/teacher_view_students_overview_button.jpg'),
          video: 'content/teacherhelp/teacher_view_students_overview.mp4',
        },
        {
          title: 'Viewing Student Activity (”Real World” Work Experience)',
          text: `The platform has been set up so you can use it as part of your regular work experience program.<br/><br/>
In this video we show you how you can view student's work experiences as part of your regular work experience program and issue them with certificates at the click of a button.`,
          image: require('@/assets/images/teacherhelp/teacher_view_student_real_world_button.jpg'),
          video: 'content/teacherhelp/teacher_view_student_real_world.mp4',
        },
        {
          title: 'Viewing Student Activity (Virtual Work Experience)',
          text: `The heart of the system - how you can view the virtual experiences that your students have undertaken. <br/><br/>
We look at how you can view the activities they have completed and issue them with a work experience certificate at the click of a button.`,
          image: require('@/assets/images/teacherhelp/teacher_view_student_virtual_button.jpg'),
          video: 'content/teacherhelp/teacher_view_student_virtual.mp4',
        },
        {
          title: 'Notifications & Certificates',
          text: `
We've made it really easy to issue students who have completed work experience (real world or virtual) with a work experience certificate. It's literally the click of a button.<br/><br/>
Further to that, we've built in a 2 way notification system that lets you  know when a student has requested a certificate and lets the student know when you have approved it.<br/><br/>
Real World” Certificates covered from 1:37<br/>
Virtual Job Experience Certificates covered at 4:00`,
          image: require('@/assets/images/teacherhelp/teacher_notifications_certificates_button.jpg'),
          video: 'content/teacherhelp/teacher_notifications_certificates.mp4',
        },
        {
          title: 'Adding Multiple Teachers/Email Notifications',
          text: `
We have now made it so students can select which teacher they want to send their job experience and certificate request to. There is also now the facility for teachers to receive email notifications when students submit a job experience to them or request a certificate from them.<br/><br/>
This video steps you through both features.`,
          image: require('@/assets/images/teacherhelp/teacher_multiple_teachers_emails_button.jpg'),
          video: 'content/teacherhelp/teacher_multiple_teachers_emails.mp4',
        },
        {
          title: 'Make a Suggestion',
          text: `We love to hear your thoughts and ideas - it's how we build a better system for you.<br/><br/>
Here's how you can let us know.`,
          image: require('@/assets/images/teacherhelp/teacher_make_suggestion_button.jpg'),
          video: 'content/teacherhelp/teacher_make_suggestion.mp4',
        },
      ],
      help_items_documents: [
        {
          title: 'Virtual Job Experience - Jobs List',
          text: `This document contains the current list of Virtual Job Experiences that students can access. As new experiences are added each fortnight you will need to keep checking in for the latest version of this list.`,
          image: require('@/assets/images/teacherhelp/teacher_help_jobs_list.png'),
          url: 'content/teacherhelp/vje_jobs_list.pdf',
        },
        {
          title: 'Quick Tick Marking Scaffold',
          text: `Assessing, marking or checking students Job Experiences is <u>optional</u>. However, you can use this guide as a reference. It will be constantly updated with new job experiences and further detail, so you will need to check in regularly for new versions. `,
          image: require('@/assets/images/teacherhelp/marking_scaffold_button_updated.png'),
          url: 'content/teacherhelp/vje_teacher_checklist.pdf',
        },
      ],
      student_help_items_videos: [
        {
          title: 'Overview:',
          text: `A quick overview of the various part of the Virtual Job Experience platform.<br/><br/>
What is it, where is it and what does it do?`,
          image: require('@/assets/images/studenthelp/student_help_overview.jpg'),
          video: 'content/studenthelp/student_help_overview_1000.mp4',
        },
        {
          title: 'Pre Work Experience:',
          text: `This video covers the various activities you may be asked to do before starting your Virtual Job Experience or even school Work Experience.`,
          image: require('@/assets/images/studenthelp/student_help_pre_work.jpg'),
          video: 'content/studenthelp/student_help_pre_work_1000.mp4',
        },
        {
          title: 'Completing Virtual Experiences:',
          text: `A complete walkthrough of how to select and complete a virtual experience.`,
          image: require('@/assets/images/studenthelp/student_help_virtual.jpg'),
          video: 'content/studenthelp/student_help_virtual_1000.mp4',
        },
        {
          title: '“Real World” Work Experience:',
          text: `Your teacher may ask you to use this system as part of your regular school Work Experience program. This video shows you how you do this.`,
          image: require('@/assets/images/studenthelp/student_help_real_world.jpg'),
          video: 'content/studenthelp/student_help_real_world_1000.mp4',
        },
        {
          title: 'Post (After) Work Experience:',
          text: `You may be required to complete some steps after you have completed your experience. This videos steps you through these.`,
          image: require('@/assets/images/studenthelp/student_help_post_work.jpg'),
          video: 'content/studenthelp/student_help_post_work_1000.mp4',
        },
        {
          title: 'Work Experience Certificates (and Notifications):',
          text: `This is what you have been working towards. Work Experience certificates that you can use as part of your job search portfolio. The video will also show you the notification system that lets you know when you have certificates waiting for you.`,
          image: require('@/assets/images/studenthelp/student_help_certificates_notifications.jpg'),
          video: 'content/studenthelp/student_help_certificates_notifications_1000.mp4',
        },
      ],
    };
  },
  methods: {
    showVideoPopup(url) {
      store.dispatch(
        'popup/showVideoPopup',
        $vjeConfig.VUE_APP_VJE_PUBLIC_OBJECT_STORAGE_URL + '/' + url,
      );
    },
  },
};
</script>
